import React from 'react'
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight'
import { FiCheckCircle } from '@react-icons/all-files/fi/FiCheckCircle'
import Action from '../primitives/Action'
import Container from '../foundations/Container'
import styles from './ManagedServiceOverview.module.scss'

const ManagedServiceOverview = ({ additionalItems = [], content }) => {
  if (!content) return null

  const items = [...(content.items || [])]
  additionalItems.forEach(additionalItem => {
    const existingIndex = items.findIndex(item => (
      item.key === additionalItem.key || item.url === additionalItem.url
    ))

    if (existingIndex >= 0) {
      items[existingIndex] = { ...additionalItem, ...items[existingIndex] }
    } else {
      items.push(additionalItem)
    }
  })

  return (
    <section className={styles.section} aria-labelledby='managed-production-services-heading'>
      <Container width='wide' className={styles.container}>
        <div className={styles.intro}>
          {content.subheading && <span>{content.subheading}</span>}
          <h2 id='managed-production-services-heading'>{content.heading}</h2>
          {content.body && <p>{content.body}</p>}

          <ul className={styles.signals}>
            {(content.settings?.signals || []).map(signal => (
              <li key={signal}>
                <FiCheckCircle aria-hidden='true' />
                <span>{signal}</span>
              </li>
            ))}
          </ul>
        </div>

        <nav className={styles.services} aria-label='Managed AV production services'>
          {items.map(item => (
            <Action
              className={`${styles.service} ${item.featured ? styles.featured : ''}`.trim()}
              href={item.url}
              key={item.key}
              variant='plain'
              wrapContent={false}
              dataConversionKey={item.eventName || `homepage.managed-services.${item.key}`}
              dataConversionLocation='managed-services'
              dataConversionChannel='other'
              dataConversionSalesPath='managed'
            >
              <span>
                <strong>{item.title}</strong>
                <small>{item.body}</small>
              </span>
              <FiArrowRight aria-hidden='true' />
            </Action>
          ))}
        </nav>
      </Container>
    </section>
  )
}

export default ManagedServiceOverview
